exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-60d80ead] {\n  font-size: 0.09375rem;\n  color: #333333;\n  height: 0.1875rem;\n  line-height: 0.1875rem;\n  font-weight: bolder;\n}\n.title-right[data-v-60d80ead] {\n  display: flex;\n  align-items: center;\n}\n.more[data-v-60d80ead] {\n  background: #f3f6ff;\n  color: #1e49e2;\n  border-radius: 0.052083rem;\n  cursor: pointer;\n  font-size: 0.072917rem;\n  padding: 0 0.052083rem;\n  text-align: center;\n  font-weight: bold;\n  height: 0.166667rem;\n  line-height: 0.166667rem;\n}\n.more[data-v-60d80ead]:hover {\n  text-decoration: underline;\n}", ""]);

// exports
